import React, { PureComponent } from 'react'
import { View, ScrollView } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import Button from '../../../Atoms/Button'

import theme from '../../../../styles/theme'
import { getStore } from '../../../../store/create-store'
import { getDownloadedFiles } from '../../../../redux/files'

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.white};
`

const Body = styled(ScrollView)`
  flex: 1;
  padding: ${theme.gutterUnit}px;
`

const Section = styled(View)`
  margin-top: ${theme.gutterUnit}px;
`

const Footer = styled(View)`
  padding: ${3 * theme.gutterUnit}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colours.black};
`

const getStatus = (state) => {
  if (state.registered) {
    return 'Registered'
  } else if (state.registering) {
    return 'Registering'
  } else {
    return 'Not Registered'
  }
}

export default class Settings extends PureComponent {
  render () {
    const { onCloseDebug } = this.props
    const { device, game, team } = getStore().getState()
    return (
      <Container>
        <Body>
          <Section>
            <Text bold>Server State</Text>
            <Text>Server Ip: {device.hostname}</Text>
          </Section>
          <Section>
            <Text bold>Device State</Text>
            <Text>Id: {device.deviceId}</Text>
            <Text>Connected Server: {device.connected.toString()}</Text>
            <Text>Connected Network: {device.networkConnected.toString()}</Text>
            <Text>Status: {getStatus(device)}</Text>
          </Section>
          <Section>
            <Text bold>Game State</Text>
            <Text>Id: {game.gameId}</Text>
            <Text>Selected Round: {game.selectedRound}</Text>
            <Text>Current Round: {game.currentRound}</Text>
            <Text>State: {game.state}</Text>
          </Section>
          <Section>
            <Text bold>Team State</Text>
            <Text>Id: {team.id}</Text>
            <Text>Status: {getStatus(team)}</Text>
            <Text>Name: {team.name}</Text>
          </Section>
          <Section>
            <Text bold>Files Downloaded</Text>
            {getDownloadedFiles().map(f => {
              return <Text key={f}>{f}</Text>
            })}
          </Section>
        </Body>
        <Footer>
          <Button darkgrey rounded onPress={onCloseDebug}>
            <Text white>CANCEL</Text>
          </Button>
        </Footer>
      </Container>
    )
  }
}
